// Galeria w PETLE (wireframe/user): next na ostatnim zdjeciu -> pierwsze,
            // prev na pierwszym -> ostatnie. Dawn wylacza przyciski na krancach
            // (MutationObserver je odblokowuje), a klik na krancu przejmujemy w capture
            // ZANIM zobaczy go slider-component.
            (function () {
              var gallery = document.querySelector('.product__media-wrapper media-gallery');
              if (!gallery || gallery.dataset.snklLoop) return;
              gallery.dataset.snklLoop = '1';
              var slider = gallery.querySelector('ul.product__media-list');
              var wrap = gallery.querySelector('.slider-buttons');
              if (!slider || !wrap) return;
              // 🚨 KONTRAKT TASMY WYMUSZONY NA ELEMENCIE, NIE W ARKUSZU (2026-08-07).
              // Wolne przewijanie wisialo dotad na tym, ze nasza regula w
              // brand-sneakly.css wygra specyficznoscia z Dawnem (.slider--mobile
              // ma `scroll-snap-type: x mandatory` + `scroll-padding-left: 1.5rem`).
              // To zalozenie jest kruche: arkusz bywa nadpisywany przez rownolegle
              // sesje, aplikacje wstrzykuja wlasny CSS, a Dawn zmienia klasy przy
              // re-renderze sekcji. Styl inline bije KAZDY arkusz, wiec te trzy
              // wlasciwosci ustawiamy tutaj i temat nie ma jak wrocic do dociagania:
              //   snap none    -> tasma staje gdziekolwiek (takze miedzy zdjeciami)
              //   padding 0    -> przewiniecia sterowane przez przegladarke laduja
              //                   rowno z krawedzia, a nie 16px dalej (zrodlo "szpary")
              //   overflow-y   -> 1px nadmiaru w pionie = realna os do przewijania
              //                   palcem; zamykamy ja, zeby kadr nie drgal w gore
              slider.style.scrollSnapType = 'none';
              slider.style.scrollPaddingLeft = '0px';
              slider.style.overflowY = 'hidden';
              // 🚨 PRZYCISK Z `disabled` NIE WYSYLA KLIKNIECIA - i to jest realny,
              // niewidoczny w testach powod "strzalki nie dzialaja" (2026-08-07).
              // Sonda dispatchowala klik programowo, a taki leci NAWET na wylaczonym
              // przycisku, wiec testy przechodzily, podczas gdy palec na telefonie
              // nie wywolywal niczego. Dawn wylacza strzalki w `SliderComponent.update()`
              // przy KAZDYM zdarzeniu scroll i po re-renderze sekcji, a stara wersja
              // pilnowala tylko DWOCH konkretnych elementow zlapanych przy starcie -
              // po podmianie poddrzewa obserwator wisial na sierotach i przyciski
              // zostawaly wylaczone na zawsze. Teraz patrzymy na CALE poddrzewo
              // galerii (nowe wezly tez) i odblokowujemy takze po scrollu.
              function unDisable() {
                var b = gallery.querySelectorAll('.slider-button[disabled]');
                for (var i = 0; i < b.length; i++) b[i].removeAttribute('disabled');
              }
              new MutationObserver(unDisable).observe(gallery, {
                subtree: true, childList: true, attributes: true, attributeFilter: ['disabled']
              });
              slider.addEventListener('scroll', unDisable, { passive: true });
              unDisable();
              function slideW() {
                var it = slider.querySelector('.product__media-item');
                return it ? it.clientWidth : slider.clientWidth;
              }
              function count() { return slider.querySelectorAll('.product__media-item').length; }
              // Krzywa (0.93,0.06,0.45,1.1) 200ms - wybor uzytkownika: dlugi rozbieg,
              // gwaltowne przyspieszenie i lekkie przestrzelenie; identyczna jak
              // w lightboxie. Zyje w CSS transition (tweenTo nizej) - JS-owy solver
              // beziera usuniety razem z tweenem scrollLeft (2026-08-04).
              var DUR = 200;

              // 🚨 PRZEBUDOWA 2026-08-04 (user: animacja strzalek ma byc JAK W LIGHTBOXIE
              // na kazdej platformie): tween scrollLeft w rAF bywal dlawiony na iOS
              // (snap/momentum potrafi ignorowac programowy scrollLeft w trakcie
              // klatek). Teraz DOSLOWNIE mechanika lightboxa: transform na SLAJDACH
              // (kompozytor, ta sama krzywa CSS transition), a po dojezdzie zdjecie
              // transformow i podmiana na scrollLeft - piksel w piksel ta sama pozycja.
              // 🚨 transform idzie na DZIECI (li), nie na UL: UL jest scrollerem,
              // transform na nim przesuwalby caly clip razem z wycinkiem.
              /* 🚨 KRZYWA TYLKO DLA STRZALEK (2026-08-07). Palec NIE MA juz zadnej
                 krzywej dojazdu: po puszczeniu tasma leci wybiegiem bezwladnosciowym
                 i staje GDZIEKOLWIEK (patrz sekcja WYBIEG nizej). Poprzednia proba -
                 druga krzywa (0.17,0.84,0.44,1) dla palca, zeby dociaganie do slajdu
                 nie "cofalo" zdjec - zostala zastapiona fizyka, ktora tego problemu
                 nie ma z definicji (predkosc gasnie monotonicznie, zero przestrzelenia
                 i zero celu do dociagniecia). STRZALKI zostaja na (0.93,0.06,0.45,1.1)
                 - swiadomy wybor usera, identyczny z lightboxem.
                 🚨🚨 TO MA BYC KOMENTARZ JS, NIE LIQUID. Komentarz Liquid z
                 myslnikami (trim po obu stronach) postawiony tuz pod linia "//"
                 ZZERA znak konca linii, wiec deklaracja ponizej ladowala W SRODKU
                 komentarza "//" i strzalki lezaly na ReferenceError (bug wykryty
                 sonda 2026-08-07, byl tez na LIVE). Wewnatrz script komentarze
                 pisz po JS-owemu - i NIE cytuj tu skladni tagow Liquid, bo parser
                 czyta caly plik i policzy taki cytat jako prawdziwy tag. */
              // Y2=1 (bylo 1.1): user 2026-08-11 zgłosil overshoot w lightboxie
              // (zdjecie wyjezdzalo za pozycje koncowa i wracalo) - krzywa jest
              // deklarowana jako identyczna z lightboxem, wiec zmiana w OBU.
              var KRZYWA_STRZALKI = 'cubic-bezier(0.93,0.06,0.45,1)';
              var tweenBusy = false;
              // AUDYT plan 003 (2026-08-08): drugi tap w trakcie ~200-340ms tweenu byl
              // CICHO ODRZUCANY (if busy return) - 3 szybkie tapy = 1-2 przeskoki.
              // Teraz najnowszy cel czeka w tweenNext i rusza zaraz po finish().
              // tweenCel = cel biezacego/zakolejkowanego tweenu: scrollLeft stoi na
              // STAREJ pozycji az do commitu w finish(), wiec strzalki w trakcie
              // ruchu musza liczyc od celu, nie od scrollLeft (inaczej drugi tap
              // wyliczalby ten sam slajd i kolejka nic nie dawala).
              var tweenNext = null;
              var tweenCel = null;
              function tweenTo(target, krzywa, czas) {
                krzywa = krzywa || KRZYWA_STRZALKI;
                czas = czas || DUR;
                target = Math.max(0, Math.min(maxSL(), target)); // cel poza tasma = wizualne odbicie po commicie
                if (tweenBusy) { tweenNext = { t: target, k: krzywa, c: czas }; tweenCel = target; return; }
                var from = slider.scrollLeft;
                var dist = target - from;
                if (!dist) { tweenCel = null; return; }
                // uzytkownik z "ogranicz animacje" dostaje natychmiastowy przeskok
                if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) {
                  // scroll-behavior: smooth z component-slider.css animowalby ten
                  // "natychmiastowy" przeskok wbrew ustawieniu uzytkownika
                  var pbR = slider.style.scrollBehavior;
                  slider.style.scrollBehavior = 'auto';
                  slider.scrollLeft = target;
                  slider.style.scrollBehavior = pbR;
                  return;
                }
                tweenBusy = true;
                tweenCel = target;
                var items = slajdy();
                // slajdy sa PERMANENTNIE zrasteryzowane (translateZ(0) w
                // brand-sneakly.css, jak .sneakly-lb__slide) - start tweenu nie
                // placi hitcha promocji warstw; willChange zbedny
                items.forEach(function (it) { it.style.transition = 'none'; it.style.transform = 'translate3d(0,0,0)'; });
                var done = false;
                function finish() {
                  if (done) return; done = true;
                  items.forEach(function (it) { it.style.transition = 'none'; it.style.transform = ''; });
                  var pb = slider.style.scrollBehavior;
                  slider.style.scrollBehavior = 'auto';
                  slider.scrollLeft = target;
                  slider.style.scrollBehavior = pb;
                  tweenBusy = false;
                  // przejmij zakolejkowany cel; bez kolejki - czyscimy baze strzalek
                  if (tweenNext) {
                    var nastepny = tweenNext; tweenNext = null;
                    tweenTo(nastepny.t, nastepny.k, nastepny.c);
                  } else {
                    tweenCel = null;
                  }
                }
                requestAnimationFrame(function () {
                  // 🚨 karta w tle: rAF zamrozony -> bezpiecznik domyka tween, a ten
                  // zalegly callback odpalilby POZNIEJ i nalozyl transformy NA
                  // przewiniety scroll (podwojne przesuniecie). done = nie aplikuj.
                  if (done) return;
                  items.forEach(function (it) {
                    it.style.transition = 'transform ' + czas + 'ms ' + krzywa;
                    it.style.transform = 'translate3d(' + (-dist) + 'px,0,0)';
                  });
                });
                var last = items[items.length - 1];
                if (last) last.addEventListener('transitionend', finish, { once: true });
                setTimeout(finish, czas + 140); // bezpiecznik (karta w tle / brak transitionend)
              }
              // SWIPE v5 = NATYWNY PRZEWIJAK (2026-08-07, po diagnozie iOS).
              // Cala obsluga gestu w JS ZOSTALA USUNIETA. Powod: na iOS WebKit
              // i nasz kod wspoldzielily jeden gest. touch-action: pan-x na
              // scrollerze wprost zaprasza WebKit do przejecia poziomych pansow,
              // a e.cancelable bylo sprawdzane TYLKO przy pierwszym touchmove -
              // gdy Safari przejmowalo gest w trakcie (po momentum, przy sklejonych
              // zdarzeniach), nasze preventDefault cicho przestawalo dzialac i
              // pozycje pisalo dwoch wlascicieli naraz: WebKit w scrollLeft, my w
              // transformach slajdow. Stad hipernaczula tasma, skoki przy
              // puszczeniu i - przy krawedzi, gdzie nasza guma nakladala sie na
              // natywny bounce - przesuniete zdjecie z pustym pasem po lewej,
              // ktore zostawalo do nastepnego dotkniecia (kompozytor nie mial co
              // przemalowac). Doszly dwa koszty samego przejmowania: scrollLeft
              // stal przez caly gest, wiec Safari nie doladowywalo lazy-obrazkow
              // sasiednich slajdow i nie odpalalo Dawnowego reveal (opacity 0.01)
              // - sasiad bywal PUSTY, co czytalo sie jako dziura; a scrollWidth
              // czytany co klatke wymuszal pelny layout galerii na watku glownym.
              // Natywny scroller daje dokladnie to, o co prosil user: swobodny
              // przesuw za palcem, systemowe momentum i zatrzymanie GDZIEKOLWIEK,
              // takze miedzy zdjeciami - bo scroll-snap-type: none (brand-sneakly)
              // usuwa punkty dociagania. Zero symulacji, zero walki o gest.
              // Blokada osi pionowej: touch-action: pan-x zadeklarowany takze na
              // PRZODKU (media-gallery), ktory sam nie jest scrollerem - WebKit
              // liczy efektywne touch-action z lancucha przodkow, a wczesniejszy
              // werdykt "iOS ignoruje pan-x" pochodzil z testu, gdzie deklaracja
              // byla wylacznie na samym scrollerze.
              function slajdy() { return Array.prototype.slice.call(slider.querySelectorAll('.product__media-item')); }
              function maxSL() { return Math.max(0, slider.scrollWidth - slider.clientWidth); }

              // 🚨 OBROT EKRANU / ZMIANA SZEROKOSCI (audyt 2026-08-07): dopoki byl
              // snap, przegladarka sama wyrownywala tasme po resize. Bez snapu
              // pozycja w pikselach zostaje, wiec po obrocie kadr staje w polowie
              // dwoch zdjec i tak juz zostaje. Wyrownujemy do najblizszej krawedzi
              // BEZ animacji (to porzadkowanie, nie gest).
              var resizeT = null, ostatniaSzer = slider.clientWidth, resizeProby = 0;
              function wyrownajPoResize() {
                resizeT = null;
                var w = slideW();
                if (!w || slider.clientWidth === ostatniaSzer) { resizeProby = 0; return; }
                // 🚨 tween strzalki w locie? SPROBUJ PONOWNIE, nie odpuszczaj:
                // wczesniej obrot w trakcie animacji zjadal wyrownanie na zawsze,
                // bo szerokosc byla juz zapisana jako "obsluzona". Licznik prob
                // pilnuje, zeby anomalia nie zostawila petli 5Hz na zawsze.
                if (tweenBusy && resizeProby < 15) {
                  resizeProby++;
                  resizeT = setTimeout(wyrownajPoResize, 200);
                  return;
                }
                resizeProby = 0;
                ostatniaSzer = slider.clientWidth;
                var cel = Math.max(0, Math.min(maxSL(), Math.round(slider.scrollLeft / w) * w));
                var pb = slider.style.scrollBehavior;
                slider.style.scrollBehavior = 'auto';
                slider.scrollLeft = cel;
                slider.style.scrollBehavior = pb;
              }
              window.addEventListener('resize', function () {
                if (resizeT) clearTimeout(resizeT);
                resizeT = setTimeout(wyrownajPoResize, 160);
              });

              // 🚨 NASLUCH NA DOKUMENCIE, nie na pudelku przyciskow (2026-08-07).
              // Dawn przy re-renderze sekcji (zmiana wariantu, edytor motywu,
              // odswiezenie ceny) podmienia cale poddrzewo galerii. Listener wpiety
              // w `wrap` szedl wtedy do smieci razem ze starym elementem i strzalki
              // "przestawaly dzialac" bez sladu bledu. Dokument zyje zawsze, a
              // selektor zawezamy do TEJ galerii, wiec obce slidery sa nietkniete.
              document.addEventListener('click', function (e) {
                var b = e.target.closest && e.target.closest('.slider-button');
                if (!b) return;
                var mg = b.closest('.product__media-wrapper');
                if (!mg || !mg.contains(slider)) return; // klik z innego slidera
                var isNext = b.classList.contains('slider-button--next');
                var isPrev = b.classList.contains('slider-button--prev');
                if (!isNext && !isPrev) return;
                var n = count();
                if (n < 2) return;
                e.stopImmediatePropagation(); e.preventDefault();
                // 🚨 tasma moze stac MIEDZY zdjeciami (wolne przewijanie), wiec
                // strzalka idzie do SASIEDNIEJ krawedzi, a nie do zaokraglonego
                // indeksu + 1 (z polowy slajdu przeskakiwaloby o dwa).
                // Tolerancja 0.15, nie 0.02 (audyt 2026-08-07): przy tasmie 12px
                // przed krawedzia nastepne zdjecie jest juz praktycznie w kadrze,
                // wiec "dalej" na 0.02 robilo 12-pikselowy ruch i wygladalo na
                // martwy przycisk - trzeba bylo klikac dwa razy.
                // w trakcie tweenu scrollLeft stoi na starej pozycji - baza = cel tweenu
                var raw = (tweenCel !== null ? tweenCel : slider.scrollLeft) / slideW();
                var goIdx;
                if (isNext) { goIdx = Math.floor(raw + 0.15) + 1; if (goIdx > n - 1) goIdx = 0; }
                else { goIdx = Math.ceil(raw - 0.15) - 1; if (goIdx < 0) goIdx = n - 1; }
                tweenTo(goIdx * slideW());
              }, true);
            })();
